const DOCUMENT_CODES = {
    DOCUMENT_NIF: 'N',
    DOCUMENT_NIE: 'C',
    DOCUMENT_PASSPORT: 'P',
    DOCUMENT_OTHER: 'I',
    DOCUMENT_CC: 'CC',
    DOCUMENT_PP: 'PP',
    DOCUMENT_DN: 'DN',
    DOCUMENT_PN: 'PN',
    DOCUMENT_DA: 'DA',
    DOCUMENT_PA: 'PA',
};

module.exports = DOCUMENT_CODES;
